module.exports = __webpack_public_path__ + "img/More (Horizontal).9fd2934b.svg";